import { FC } from "react";
import DropZone from "./DropZone";
import ImageCropper from "./ImageCropper";
import ImagePreview from "./ImagePreview";
import { StyledLabel, Wrapper } from "./UploadImage.styled";

type Props = {
  cropData: any;
  setCropData: any;
  files: any;
  setFiles: any;
  label?: string;
  className?: string;
};

const UploadImage: FC<Props> = ({
  cropData,
  className,
  label,
  setCropData,
  files,
  setFiles,
}) => {
  return (
    <Wrapper className={className}>
      <StyledLabel>{label}</StyledLabel>
      <ImagePreview cropData={cropData} setCropData={setCropData} />
      <DropZone cropData={cropData} setFiles={setFiles} files={files} />
      <ImageCropper
        setCropData={setCropData}
        files={files}
        setFiles={setFiles}
      />
    </Wrapper>
  );
};

export default UploadImage;
